import { render, staticRenderFns } from "./CertifikatInput.vue?vue&type=template&id=61c97633&scoped=true&"
import script from "./CertifikatInput.vue?vue&type=script&lang=js&"
export * from "./CertifikatInput.vue?vue&type=script&lang=js&"
import style0 from "./CertifikatInput.vue?vue&type=style&index=0&id=61c97633&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c97633",
  null
  
)

export default component.exports